var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuestionCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "question-circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.99935 18.8332C14.6017 18.8332 18.3327 15.1022 18.3327 10.4998C18.3327 5.8975 14.6017 2.1665 9.99935 2.1665C5.39702 2.1665 1.66602 5.89742 1.66602 10.4998C1.66602 15.1023 5.39702 18.8332 9.99935 18.8332ZM10 16.0199C9.53977 16.0199 9.16668 15.6468 9.16668 15.1866C9.16668 14.7264 9.53977 14.3533 10 14.3533C10.4603 14.3533 10.8333 14.7263 10.8333 15.1866C10.8333 15.6468 10.4603 16.0199 10 16.0199ZM7.85727 5.75784C8.61327 5.12225 9.61302 4.86025 10.5973 5.03034C11.9409 5.26717 13.0444 6.37067 13.2813 7.71425C13.5287 9.12942 12.8564 10.543 11.6081 11.2323C11.1231 11.4993 10.8333 11.9379 10.8333 12.4058C10.8333 12.8664 10.4602 13.275 10 13.275C9.53985 13.275 9.16668 12.9389 9.16668 12.4783V12.4058C9.16668 11.3218 9.77827 10.3372 10.8033 9.77234C11.438 9.42242 11.766 8.72742 11.639 8.00234C11.5243 7.34725 10.9643 6.78734 10.3093 6.67259C9.80185 6.58225 9.3136 6.71167 8.9291 7.03475C8.55068 7.35217 8.33343 7.81767 8.33343 8.31159C8.33343 8.77217 7.96027 9.14492 7.5001 9.14492C7.03993 9.14492 6.66677 8.77217 6.66677 8.31159C6.66677 7.32442 7.10085 6.39342 7.85727 5.75784Z",
    fill: "#00E7FF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionCircle);
export default __webpack_public_path__ + "static/media/question-circle.d9f7b342112750550b92eca92bbc7da4.svg";
export { ForwardRef as ReactComponent };